(function () {
    function money(cents) {
        return new Intl.NumberFormat('en-IE', {
            style: 'currency',
            currency: window.Shopify.currency.active,
        }).format(cents / 100);
    }

    function cents(amount) {
        return amount ? Math.round(Number(amount) * 100) : 0;
    }

    function build(price, compare) {
        if (!compare || compare <= price) return null;
        return {
            compare: money(compare),
            off: Math.round(((compare - price) * 100) / compare),
        };
    }

    window.pvSale = {
        fromVariant: function (product, variantId) {
            if (!product || !product.variants) return null;
            var variant = product.variants.find(function (item) {
                return item.id === Number(variantId);
            });
            return variant ? build(variant.price, variant.compare_at_price) : null;
        },
        fromProduct: function (product) {
            return product ? build(product.price_min, product.compare_at_price_min) : null;
        },
        fromVariants: function (variants) {
            if (!variants || !variants.length) return null;
            var cheapest = variants.reduce(function (a, b) {
                return Number(b.price) < Number(a.price) ? b : a;
            });
            return build(cents(cheapest.price), cents(cheapest.compare_at_price));
        },
        label: function (sale, suffix) {
            if (!sale) return '';
            return sale.off + '% OFF' + (suffix ? ' — ' + suffix : '');
        },
    };
})();
